import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"garlic"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13.6485 2L9.64851 4.5C9.64851 4.5 10.2483 5.56893 10.2172 6.5821C8.57914 10.594 1.99974 10.594 2 17.0017C2.00011 19.6668 3.85134 22 6.64811 22C8.23232 22 9.50767 21.4179 9.50767 21.4179C9.9671 21.7307 10.6481 22 11.6481 22C12.5575 22 13.3683 21.8719 14.0279 21.5519C20.3942 23.0369 22.3219 19.5083 21.9541 16.0441C21.313 9.45758 13.6485 9.20662 13.6485 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.7495 21.7025C20.5404 22.7629 22.3076 19.3738 21.9541 16.0441C21.3129 9.45758 13.6485 9.20662 13.6485 2L9.64851 4.5C9.64851 4.5 10.2483 5.56893 10.2172 6.5821C8.57914 10.594 1.99974 10.594 2 17.0017C2.00011 19.6668 3.85134 22 6.64811 22C7.6571 22 8.5408 21.7639 9.04951 21.5924M13.6485 10C13.6485 12.5 14.7607 13.0624 15.5356 15.5312C16.3105 18 15.5441 20.8164 14.0279 21.5519C13.3683 21.8719 12.5575 22 11.6481 22C10.6481 22 9.96708 21.7307 9.50765 21.4179C7.6295 20.1393 6.71828 16.7024 8.94715 11.8101C9.5403 10.3056 9.87641 9.09152 10.0527 8.1C10.0771 7.96244 10.0985 7.82917 10.1171 7.7C10.1195 7.68326 10.1218 7.6666 10.1242 7.65","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Garlic = Vue.extend<IconProps>({
  name: 'GarlicIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'garlic',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Garlic;
